// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__8iotY","tagButton":"styles_tagButton__XpyV_","icon":"styles_icon__4UVsD","label":"styles_label__T12nU"};